// Define interfaces for the data structure
interface Notification {
	event_id: number
	title: string
	data: string
	displayOrder: number
	startsAt: string
}

interface NotificationsState {
	notifications: Notification[]
	showCount: number
}

function parseDate(utcDateString: string) {
	const date = new Date(utcDateString)
	const year = date.getFullYear()
	const month = String(date.getMonth() + 1).padStart(2, "0")
	const day = String(date.getDate()).padStart(2, "0")
	// Format as YYYY-MM-DD
	return `${year}-${month}-${day}`
}

function convertJsonToNotification(json: any): Notification {
	return {
		event_id: json.event_id,
		title: json.title,
		data: json.data,
		displayOrder: json.display_order,
		startsAt: json.starts_at ? parseDate(json.starts_at) : "",
	}
}

// Define the Pinia store
export const useNotificationStore = defineStore("notificationStore", {
	state: (): NotificationsState => ({
		notifications: [],
		showCount: 0, //Value used to control the view/hide buttons
	}),

	getters: {
		getAll: (state: NotificationsState) => () => {
			return state.notifications
		},
		getShowCount: (state: NotificationsState) => () => {
			return state.showCount
		},
	},

	actions: {
		storeNotificationsFromJson(notifications: any) {
			notifications.forEach((notif: any) => {
				this.notifications.push(convertJsonToNotification(notif))
			})
		},
		clear() {
			this.notifications = []
			this.showCount = 0
		},
		incrementShowCount() {
			this.showCount = ++this.showCount
		},
		decrementShowCount() {
			this.showCount = --this.showCount
		},
		clearShowCount() {
			this.showCount = 0
		},
	},

	persist: {
		key: "up_notificationStore", // Make sure this key is unique
		storage: localStorage, // or cookies if you're using cookie storage
	},
})
